import { render, staticRenderFns } from "./BanHistoryCard.vue?vue&type=template&id=5dd6fe9e&scoped=true"
import script from "./BanHistoryCard.vue?vue&type=script&lang=js"
export * from "./BanHistoryCard.vue?vue&type=script&lang=js"
import style0 from "./BanHistoryCard.vue?vue&type=style&index=0&id=5dd6fe9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd6fe9e",
  null
  
)

export default component.exports